import { yupResolver } from "@hookform/resolvers/yup";
import { Checkbox, FormLabel, Input } from "@mui/material";
import { ChangeEvent } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";
import { FieldContainer } from "../../components/FieldContainer";

const menuItems = [
  "Lineup",
  "Showcase",
  "Clashfinder",
  "ClashfinderExport",
  "ClashfinderSharing",
  "SharedClashfinders",
  "Traders",
  "Food",
  "Info",
  "InfoMain",
  "Sponsors",
  "SponsorsMain",
  "SponsorsMore",
  "Bar",
  "Reminders",
  "Map",
  "VIP",
  "Mapbox"
];

const schema = yup
  .object({
    enabledScreens: yup.string(),
    checkboxValues: yup
      .array()
      .of(yup.object({ name: yup.string(), checked: yup.bool() })),
  })
  .required();

export const ScreenSelector = ({
  items,
  onChange,
}: {
  items: string;
  onChange: (items: string) => void;
}) => {
  const defaultCheckboxes = menuItems.map((item) => {
    const checked = items?.split(",")?.includes(item);

    return {
      name: item,
      checked: !!checked,
    };
  });

  console.log("defaultCheckboxes", defaultCheckboxes);

  const { register, handleSubmit, watch, control, setValue, formState } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues: {
        checkboxValues: defaultCheckboxes,
      },
    });

  // for mutation.
  //   const names = checkboxValues.flatMap((item: any) => {
  //     if (!item.checked) return [];
  //     return [item.name];
  //   });
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "checkboxValues", // unique name for your Field Array
    }
  );

  const onSubmit = (val: any) => {
    const { checkboxValues } = val;

    const names = checkboxValues.flatMap((item: any) => {
      if (!item.checked) return [];
      return [item.name];
    });

    onChange(names.join(","));
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="enabledScreens"
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <Input
              type="hidden"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
            />
          )}
        />
        {fields.map((row, index) => (
          <Controller
            key={row.name}
            control={control}
            name={`checkboxValues.${index}.name`}
            render={({ field }) => (
              <div>                
                <Checkbox                  
                  id="outlined-basic"
                  {...field}
                  defaultChecked={row.checked}
                  onChange={(
                    event: ChangeEvent<HTMLInputElement>,
                    checked: boolean
                  ) => {
                    setValue(`checkboxValues.${index}.checked`, checked);
                    handleSubmit(onSubmit)();
                  }}
                />
                <FormLabel>{row.name}</FormLabel>
              </div>
            )}
          />
        ))}
      </form>
    </div>
  );
};
